import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import Image from "next/image"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 16px;
  padding-top: 24px;
`

const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 32px;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 300px;
    margin-top: 160px;
  }
`

type Props = {
  isFormError: boolean
  setSubmitForm: any
  setIsFormError: any
}

export default function FormResult({
  isFormError,
  setSubmitForm,
  setIsFormError,
}: Props) {
  const clickHandler = () => {
    setSubmitForm(false)
    setIsFormError(false)
  }

  return (
    <StyledLayout>
      {isFormError && (
        <Image
          src={"/icons/formError.svg"}
          width={80}
          height={80}
          alt="failed"
        />
      )}
      {!isFormError && (
        <Image
          src={"/icons/formSuccess.gif"}
          width={100}
          height={100}
          alt="success"
        />
      )}
      {isFormError && (
        <TextBox>
          <Typography variant="h3">משהו השתבש בדרך אלינו...</Typography>
          <Typography variant="body1">
            כנראה שהיתה שגיאה בשליחת הפנייה. אפשר לנסות שוב
          </Typography>
        </TextBox>
      )}
      {!isFormError && (
        <TextBox role="alert">
          <Typography variant="h3">
            תודה. <br></br>העברנו את פרטיך לטיפול
          </Typography>
          <Typography variant="body1">
            עלית על הדרך לקריירה באגד.
            <br />
            נחזור אליך בקרוב
          </Typography>
        </TextBox>
      )}

      <StyledButton variant="primary" onClick={clickHandler}>
        {isFormError ? " ניסיון נוסף" : "חזרה לעמוד קריירה"}
      </StyledButton>
    </StyledLayout>
  )
}
